<style src="./NewDocumentType.scss" lang="scss" scoped></style>
<template>
  <section class="new-document-type">
    <form
      class="form"
      @submit.prevent="submitForm">
      <label class="form-field">
        <span class="title">Título do documento</span>
        <input
          type="text"
          v-model="form.title"
          placeholder="Edital"
          class="cp1-small-textbox" />
      </label>

      <label class="form-field">
        <span class="title">Descrição</span>
        <textarea
          type="text"
          v-model="form.description"
          placeholder="Uma breve descrição do que se trata o documento"
          class="cp1-small-textbox textdescription">
        </textarea>
      </label>

      <cp1-form-group
        class="formgroup"
        caption="Definir os campos do documento"
        description="Utilize o formulário abaixo para criar campos pesquisáveis sobre esse documento">
        <form
          class="documentfields"
          @submit.prevent="addField">
          <label class="form-field doctype">
            <span class="title">Tipo do campo</span>
            <select
              class="cp1-small-select field"
              v-model="fields.inputType">
              <option :value="null">Selecione o tipo</option>
              <option
                v-for="(fieldType, fieldTypreIdx) in fields.fieldTypes"
                :key="fieldTypreIdx"
                :value="fieldType.inputType">{{ fieldType.caption }}</option>
            </select>
          </label>

          <label class="form-field doctitle">
            <span class="title">Título</span>
            <input
              type="text"
              v-model="fields.caption"
              placeholder="Número do documnento"
              class="cp1-small-textbox textdescription" />
          </label>

          <button
            class="cp1-small-button cp1-button__primary addfield">
            Adicionar
          </button>
        </form>
      </cp1-form-group>

      <cp1-form-group
        class="formgroup"
        caption="Listagem dos campos inseridos">
        <ul class="fieldslist">
          <li class="fieldheader">
            <span class="fieldtype">Tipo do campo</span>
            <span class="fieldtitle">Título</span>
          </li>
          <li
            class="emptylist"
            v-if="form.fields.length === 0">
            <icon-empty class="icon" />
            Não há campos
          </li>
          <li
            class="fielditem"
            v-for="(fieldItem, fieldItemIdx) in form.fields"
            :key="fieldItemIdx">
            <span class="fieldtype">
              {{ fieldItem.inputType }}
            </span>
            <span class="fieldtitle">
              {{ fieldItem.caption }}
            </span>
            <button
              type="button"
              class="btnremove"
              @click="removeField(fieldItemIdx)">
              <icon-garbage class="icon" />
            </button>
          </li>
        </ul>
      </cp1-form-group>

      <div class="commands">
        <button
          type="button"
          class="cp1-small-button cp1-button__ghost cp1-button__text__warning commandbutton"
          @click="cleanForm">
          Fechar sem Salvar
        </button>

        <cp1-button-submit
          :disabled="isSubmitDisabled"
          class="commandbutton"
          :state="commands.submitState">
          Salvar
        </cp1-button-submit>
      </div>
    </form>
  </section>
</template>

<script>
import { IconWait, IconSave, IconEmpty, IconGarbage } from '@/components/primitives/icons'

export default {
  name: 'NewDocumentType',
  components: {
    IconWait,
    IconSave,
    IconEmpty,
    IconGarbage
  },
  data () {
    return {
      form: {
        title: '',
        description: '',
        fields: []
      },
      commands: {
        saveIcon: IconSave,
        submitState: 'REPOSE'
      },
      fields: {
        caption: null,
        inputType: null,
        fieldTypes: [
          { caption: 'Texto', inputType: 'cp1-textbox' },
          { caption: 'Data', inputType: 'cp1-datebox' },
          { caption: 'Monetário', inputType: 'cp1-moneybox' }
        ]
      }
    }
  },
  computed: {
    isSubmitDisabled () {
      const haveTitle = this.form.title.length > 2
      const haveDescription = this.form.description.length > 2
      return !(haveTitle && haveDescription)
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    changePanelTab (pPanelItemId) {
      this.panelTab.panelTabChoose = pPanelItemId
    },
    addField () {
      const fieldPayload = {
        caption: this.fields.caption,
        inputType: this.fields.inputType
      }
      this.form.fields.push(fieldPayload)
      this.cleanFormField()
    },
    resetFieldForm () {
      this.fields.caption = null
      this.fields.inputType = null
    },
    removeField (fieldIdx) {
      const fields = [...this.form.fields]
      fields.splice(fieldIdx, 1)
      this.form.fields = fields
    },
    async submitForm () {
      try {
        this.commands.submitState = 'WAIT'
        if (this.form.title.trim().length < 2) {
          throw new Error('Campo título não preenchido')
        }
        const form = { ...this.form }
        const result = await this.$store.dispatch('DocumentType/ADD_NEW', form)
        if (result) {
          this.$toasted.success('Tipo de document salvo com sucesso')
          await this.$store.dispatch('DocumentType/LIST_PAGINATED')
          this.closePanel()
        }
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
      }
    },
    cleanFormField () {
      this.fields.inputType = null
      this.fields.caption = ''
    },
    cleanForm () {
      this.cleanFormField()
      this.form.title = ''
      this.form.description = ''
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/document-type/components/new-document-type/NewDocumentType.vue